import { useTranslation } from 'react-i18next';
import { PERMISSION_GROUPS_URL } from '../../../../api/permissions';
import { USERS_URL } from '../../../../api/users';
import { useHasPermission } from '../../../../contexts/auth';
import { useListCount } from '../../../../hooks/useListCount';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import { TenantSection } from './tenantSection.component';

/** Who can sign in, and what each of them is allowed to do. */
export const TenantAccessSection = () => {
  const { t } = useTranslation();
  const canViewUsers = useHasPermission('users.view_user');
  const canViewGroups = useHasPermission('auth.view_group');
  const usersCount = useListCount(USERS_URL, canViewUsers);
  const groupsCount = useListCount(PERMISSION_GROUPS_URL, canViewGroups);

  return (
    <TenantSection
      tabs={[
        ...(canViewUsers
          ? [{ key: 'users', label: t('Users'), path: TENANT_ROUTES.users, count: usersCount }]
          : []),
        ...(canViewGroups
          ? [
              {
                key: 'groups',
                label: t('Permission Groups'),
                path: TENANT_ROUTES.permissionGroups,
                count: groupsCount,
              },
            ]
          : []),
      ]}
    />
  );
};
